export function encodePassphrase(passphrase: string) {
  return encodeURIComponent(passphrase);
}

export function decodePassphrase(base64String: string) {
  return decodeURIComponent(base64String);
}

export function generateRoomId(): string {
  // salon-Präfix: der Eva-Salon-Worker joint salon-*-Räume + die Token-Route
  // dispatcht Eva nur in salon-*. So ist Eva in jedem erzeugten Raum dabei.
  return `salon-${randomString(4)}-${randomString(4)}`;
}

export function randomString(length: number): string {
  // Kryptografisch sicher (crypto.getRandomValues, Browser + Node ≥19): randomString
  // erzeugt u.a. die E2EE-Passphrase (randomString(64)) — Math.random wäre vorhersagbar.
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const values = new Uint32Array(length);
  crypto.getRandomValues(values);
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(values[i] % characters.length);
  }
  return result;
}

export function isLowPowerDevice() {
  return navigator.hardwareConcurrency < 6;
}

// Regie-Admins (Welle 5): die frühere namensbasierte Allowlist (isSalonAdmin /
// NEXT_PUBLIC_MEET_ADMINS) wurde entfernt — sie war unsicher (jeder Gast konnte sich
// „Gerd" nennen und Eva über den Regie-Kanal kapern). Der Co-Moderator kommt jetzt über
// den geheimen Regie-Link (?regie=<adminSecret>); der Server signiert daraufhin das
// salon_admin-Token-Attribut, das der Worker prüft, und bestätigt es dem Frontend über
// ConnectionDetails.isAdmin (siehe PageClientImpl / connection-details / waiting-store).

export function isMeetStaging() {
  return new URL(location.origin).host === 'meet.staging.livekit.io';
}
